module.exports = __webpack_public_path__ + "4955bd3bedff62cbb520bf1296b5c197.png";